import { createSlice } from '@reduxjs/toolkit'
import {getFactoryCasesByPlate, refreshFactoryCasesByPlate } from "./thunks"
import { logOut } from '../authentication/authenticationSlice';
import dayjs from 'dayjs';

const initialState= { 
  factoryCases: [],
  tableActiveCommentForm: null,
  masterDetailExpandedRows: [], 
  orderBy:{columna: "entryDate", orderAsc: false},
  loading: "idle",
  error: null }

const factoryCasesSlice = createSlice({
  name: 'factoryCases',
  initialState,
  reducers: {
    clearFactoryCasesError: (state)=>{
      state.error = null
      state.loading = "idle"
    },
    clearFactoryCases: (state)=>{
      state.error = null;
      state.loading = "idle";
      state.factoryCases = []
    },
    setTableActiveCommentForm: (state, action)=>{
      state.tableActiveCommentForm = action.payload
    },
    setMasterDetailExpandedRow: (state, action)=>{
      state.masterDetailExpandedRows = [...state.masterDetailExpandedRows, action.payload]
    },
    removeMasterDetailExpandedRow: (state, action)=>{
      state.masterDetailExpandedRows = state.masterDetailExpandedRows.filter(expandedRow => expandedRow !== action.payload) 
    },
    removeAllMasterDetailExpandedRows: (state, action)=>{
      state.masterDetailExpandedRows = []
    },
    setFactoryTableSortSettings:(state,action)=>{
      state.orderBy = action.payload
    }
  },
  extraReducers: {
    [getFactoryCasesByPlate.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactoryCasesByPlate.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.factoryCases = action.payload.map(fc=> ({...fc, entryDate : dayjs(fc.entryDate, "DD/MM/YYYY hh:mm:ss").format(), closeDate: fc.closeDate && dayjs(fc.closeDate, "DD/MM/YYYY hh:mm:ss").format()}))
    },
    [getFactoryCasesByPlate.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [refreshFactoryCasesByPlate.pending]: (state) => {
        state.loading = "updating"; 
        state.error = null
      },
    [refreshFactoryCasesByPlate.fulfilled]: (state, action) => {
        state.loading = "succeeded";
        state.factoryCases = action.payload.map(fc=> ({...fc, entryDate : dayjs(fc.entryDate, "DD/MM/YYYY hh:mm:ss").format(), closeDate: fc.closeDate && dayjs(fc.closeDate, "DD/MM/YYYY hh:mm:ss").format()}))
    },
    [refreshFactoryCasesByPlate.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {setFactoryTableSortSettings, clearFactoryCasesError, clearFactoryCases, setTableActiveCommentForm, setMasterDetailExpandedRow, removeMasterDetailExpandedRow, removeAllMasterDetailExpandedRows} = factoryCasesSlice.actions;
export default factoryCasesSlice.reducer
